<template>
  <div>
    <div class="size-select-list">
      <label class="label"
        >选择参数(<span style="color: #f56c6c">{{ selectedIds.length }}</span> / {{ elementList.length }}):</label
      >
      <el-checkbox-group v-model="selectedIds" class="checkbox-group">
        <el-checkbox v-for="item in elementList" :key="item.id" :label="item.id" :disabled="item.necessary"> {{ item.name }}</el-checkbox>
      </el-checkbox-group>
    </div>
    <el-table :data="tableList">
      <el-table-column width="120px" fixed="left" key="sizeValue" prop="sizeValue" :label="sizeGroup.name"> </el-table-column>
      <el-table-column v-for="(col, cIndex) in tableCols" :key="col.prop" :prop="col.prop" v-bind="col.attrs">
        <template slot="header" slot-scope="scope">
          <span v-if="col.required" style="color: red">*</span>
          {{ col.label }}
          <template>
            <el-checkbox v-model="col.isRange">平量拉量</el-checkbox>
          </template>
        </template>
        <template slot-scope="{ row }">
          <el-form-item :inline-message="true" :error="row[`${col.prop}Error`]">
            <template v-if="col.isRange">
              <el-input-digit
                v-model.number="row[col.prop].valueStart"
                placeholder="请输入平量"
                :nullable="true"
                v-bind="col.input.attrs"
                style="width: 80px"
              />
              -
              <el-input-digit
                v-model.number="row[col.prop].valueEnd"
                placeholder="请输入拉量"
                :nullable="true"
                v-bind="col.input.attrs"
                style="width: 80px"
              />
            </template>
            <el-input-digit
              v-else
              v-model.number="row[col.prop].valueStart"
              :nullable="true"
              style="width: 130px"
              v-bind="col.input.attrs"
            />
          </el-form-item>
        </template>
      </el-table-column>
    </el-table>
    <!-- <div style="margin: 10px"><el-button type="primary" @click="toCreateSizecharts">创建尺码表模版</el-button></div> -->
  </div>
</template>
  
  <script>
import { getSizecharts, getSizechartsClass, getSizechartsSettings, createSizecharts } from '@/servers/prod/center/temu.js';
import { cloneDeep } from 'lodash';

export default {
  props: {
    sizeSpec: {
      type: Object,
      default: () => {},
    },
    elementList: {
      type: Array,
      default: () => [],
    },
    sizeGroupList: {
      type: Array,
      default: () => [],
    },
    sizeTemplate: {
      type: [Object, Array],
      default: () => {},
    },
    shopId: Number,
    categoryId: [String, Number],
  },
  data() {
    return {
      classId: '',
      tableList: [],
      selectedIds: [],
      tableCols: [],
      sizeGroup: {},
    };
  },
  watch: {
    categoryId: {
      async handler(val) {
        if (val) {
          this.handleSelectIds();
        }
      },
      immediate: true,
    },
    selectedIds: {
      handler() {
        this.tableCols = this.elementList
          .filter(item => this.selectedIds.includes(item.id))
          .map(item => {
            const findCol = this.tableCols.find(col => col.prop === item.id);
            if (findCol) return findCol;
            return {
              prop: item.id,
              label: item.name,
              necessary: item.necessary,
              isRange: false,
              attrs: {
                width: '200px',
              },
              input: {
                attrs: {
                  precision: 1,
                },
              },
            };
          });
      },
      deep: true,
      immediate: true,
    },
    tableCols: {
      handler(val) {
        if (val?.length) {
          this.initTableList();
        }
      },
      deep: true,
    },
    sizeSpec: {
      async handler(val) {
        let sizeGroup = { id: 201, name: '无规格默认尺码' };
        if (val) {
          const findGroup = this.sizeGroupList.find(group => group.name === val.name);
          sizeGroup = { ...sizeGroup, ...findGroup };
          if(!val.isSale){
            sizeGroup.id = 101;
          }
        }
        this.sizeGroup = sizeGroup;
        this.initTableList();
      },
      deep: true,
      immediate: true,
    },
    tableList: {
      handler() {
        const errMsg = this.validate();
        this.$emit('validate-errMsg', errMsg);
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    handleSelectIds() {
      const requiredList = this.elementList.filter(item => item.necessary);
      const templateElementList = this.sizeTemplate?.content?.meta?.elementList || [];
      const selectedSet = new Set(this.selectedIds);
      const allElements = [...requiredList, ...templateElementList];

      allElements.forEach(item => {
        selectedSet.add(item.id);
      });

      this.selectedIds = Array.from(selectedSet);
    },
    initTableList() {
      if (this.sizeSpec && !this.sizeSpec.values?.length) {
        this.tableList = [];
        return;
      }

      let valueItems = this.sizeSpec?.values;
      if (!this.sizeSpec) {
        valueItems = [{ value: 'size' }];
      }

      const records = this.sizeTemplate?.content?.records || [];
      const recordsMap = new Map();
      // 预先构建记录映射，提高查找效率
      records.forEach(record => {
        const sizeValue = record?.values?.[this.sizeGroup.id];
        if (sizeValue) {
          recordsMap.set(sizeValue, record?.values || {});
        }
      });
      this.tableList = valueItems.map(v => {
        const tableItem = {
          sizeId: this.sizeGroup.id,
          sizeValue: v.value,
        };
        // 从现有表格数据中查找
        const existingItem = this.tableList.find(row => row.sizeValue === tableItem.sizeValue);
        const templateRecord = recordsMap.get(tableItem.sizeValue);
        // 初始化列数据
        this.tableCols.forEach(col => {
          let colData = { id: col.prop, valueStart: '', valueEnd: '' };
          // 优先使用现有数据
          if (existingItem?.[col.prop]) {
            colData = { ...existingItem[col.prop] };
          } else if (templateRecord?.[col.prop]) {
            // 其次使用模板数据
            const valList = templateRecord[col.prop].split('-');
            colData = {
              id: col.prop,
              valueStart: valList[0] || '',
              valueEnd: valList[1] || '',
            };
            // 检查是否为范围值
            if (col.isRange !== !!colData.valueEnd) {
              col.isRange = !!colData.valueEnd;
            }
          }
          tableItem[col.prop] = colData;
        });
        return tableItem;
      });
    },
    async method_getSizeData() {
      await this.getClass();
      const elementList = this.selectedIds.map(id => this.elementList.find(el => el.id === id)).filter(Boolean);
      const records = this.tableList.map(item => {
        const values = { [item.sizeId]: item.sizeValue };
        this.tableCols.forEach(col => {
          const colData = item[col.prop];
          if (colData) {
            values[col.prop] = col.isRange ? `${colData.valueStart}-${colData.valueEnd}` : String(colData.valueStart || '');
          }
        });
        return {
          values,
        };
      });
      let groupList = [
        {
          name: this.sizeGroup.name,
          id: this.sizeGroup.id,
        },
      ];
      return {
        name: `尺码表_${new Date().getTime()}`,
        classId: this.classId,
        catId: this.categoryId,
        reusable: false,
        content: {
          generalSizeType: this.sizeGroup.id,
          localSizeSource: 1,
          records,
          meta: {
            elementList,
            groupList,
          },
        },
      };
    },
    validate() {
      for (const item of this.tableList) {
        for (const col of this.tableCols) {
          const colData = item[col.prop];
          if (!colData) continue;
          if (col.isRange) {
            if (!colData.valueStart || !colData.valueEnd) {
              return `尺码：${item.sizeValue}、${col.label}的平量和拉量必填`;
            }
          } else if (!colData.valueStart) {
            return `尺码：${item.sizeValue}、${col.label}的值必填`;
          }
        }
      }
      return '';
    },
    async toCreateSizecharts() {
      const data = await this.method_getSizeData();
      const res = await createSizecharts(data);
      if (res) {
        this.$message.success('创建成功');
      }
    },
    async getList() {
      const res = await getSizecharts({ shopId: this.shopId, catId: this.categoryId });
    },
    async getClass() {
      const res = await getSizechartsClass({ shopId: this.shopId, catId: this.categoryId });
      this.classId = res?.classId || '';
    },
    async getSettings() {
      const res = await getSizechartsSettings({ shopId: this.shopId, catId: this.categoryId });
    },
  },
};
</script>
<style lang="scss" scoped>
.size-select-list {
  display: flex;
  background: #f9f5f5;
  margin: 5px;
  padding: 10px;
  border-radius: 8px;
  .label {
    width: 120px;
    text-align: right;
  }
  .checkbox-group {
    padding: 0px 10px 10px;
    flex: 1;
  }
}
</style>
  